<template>
  <Portal>
    <Modal class="terms-modal" :is-open="isOpen" @close="$emit('close')">
      <Heading :level="3">Leia e aceite o contrato</Heading>
      <ContentDisplay
        class="terms-modal__content"
        footer-label="Ler contrato"
        footer-type="link"
        @click="goToTerms"
      >
        <template #content-block-1>
          <Heading :level="6">{{ data.title }}</Heading>
          <BaseText class="terms-modal__description" size="p4">
            {{ data.description }}
          </BaseText>
        </template>
      </ContentDisplay>
      <template #buttonContainer>
        <ButtonContainer>
          <template #button-primary>
            <ButtonPrimary
              size="large"
              label="Aceitar"
              :loading="isLoading"
              @click="fetchAcceptTerms"
            />
          </template>
          <template #button-secondary>
            <ButtonSecondary
              size="large"
              label="Cancelar"
              @click="$emit('close')"
            />
          </template>
        </ButtonContainer>
      </template>
    </Modal>
  </Portal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  Modal,
  Heading,
  ContentDisplay,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

import {
  termsSignature,
  ITerms
} from '@/modules/catalog/services/variable-income';

interface Props {
  data: ITerms;
  templateId: string;
  isOpen: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'accept', request: string): void;
}

const { data, templateId } = defineProps<Props>();

const emit = defineEmits<EmitEvents>();

const isLoading = ref(false);

function goToTerms() {
  window.open(data.url, '_blank');
}

async function fetchAcceptTerms() {
  try {
    isLoading.value = true;

    const { request } = await termsSignature(templateId);

    emit('accept', request);
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });

    emit('close');
  } finally {
    isLoading.value = false;
  }
}
</script>

<style lang="less" scoped>
.terms-modal {
  :deep(.base-modal--wrapper) {
    max-width: 592px;
  }
  :deep(.modal-content) {
    align-items: flex-start;
    text-align: left;
    padding: 0 @size-spacing-x1000 @size-spacing-x1000;
  }
  &__content {
    margin-top: @size-spacing-x600;
  }
  &__description {
    margin-top: @size-spacing-x500;
  }
}
</style>
